import React from "react";
import SearchingIcon from "./SearchingIcon";

const Searching = ({ provider }) => {
    return (
        <div className="searching-icon-container">
            <SearchingIcon />
        </div>
    );
};

export default Searching;
